import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	firebaseReady: false,
	firebaseToken: null,
	// Why sign-in was refused, to show the user (e.g. their account was deactivated)
	signInError: null,
};

export const firebaseSlice = createSlice({
	name: 'firebase',
	initialState,
	reducers: {
		setFirebaseReady: (state, action) => {
			state.firebaseReady = action.payload;
		},
		setFirebaseToken: (state, action) => {
			state.firebaseToken = action.payload;
		},
		clearFirebaseToken: (state) => {
			state.firebaseToken = null;
		},
		setSignInError: (state, action) => {
			state.signInError = action.payload;
		},
		resetFirebase: (state) => {
			state.firebaseReady = false;
			state.firebaseToken = null;
		},
	},
});

export const {
	setFirebaseReady,
	resetFirebase,
	setFirebaseToken,
	clearFirebaseToken,
	setSignInError,
} = firebaseSlice.actions;
export default firebaseSlice.reducer;
